// Navbar.js
import React, { useState } from "react";

// Styling Import
import "../styles/Navbar.css"
import LKCLogo from "../images/Global/lkc_logo.png"

// React-Bootstrap Imports // 
import Navbar from "react-bootstrap/Navbar"; // Changed the import to use "Navbar"
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from 'react-bootstrap/NavDropdown'
import "bootstrap/dist/css/bootstrap.min.css";
// ----------------------- //

// React-Router Imports //
import { Link, useLocation } from "react-router-dom";
// -------------------- //


// Functions for Navbar Logic //
function NavbarComponent({toggleLeftSidebar, leftsidebarOpen}) {
  // Use state to control the expanded/collapsed state of the navbar
  const [expanded, setExpanded] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation(); // Get the current path

  // Function to close the navbar when a navigation link is clicked
  const closeNav = () => {
    setExpanded(false);
  };

  const handleDropdownMouseEnter = () => {
    setDropdownOpen(true);
  };

  const handleDropdownMouseLeave = () => {
    setDropdownOpen(false);
  };

  const isSubComponentActive = (path) => {
    return window.location.pathname === path;
  };

  const isMainComponentActive = () => {
    // Check if any subcomponent is active
    return (
      isSubComponentActive("/gpt-3-5/rag") ||
      isSubComponentActive("/gpt-4/rag") ||
      isSubComponentActive("/gpt-4o/rag")
      // Add more subcomponent paths as needed

    );
  };

  // Check if the current path is "/dashboard"
  const isDashboard = location.pathname === "/dashboard";
  // ------------------------------------------- //

  return (
    <Navbar expand="md" expanded={expanded}>
      <Container>
        {/* Sidebar toggle button for mobile screens */}
        {!isDashboard && (
          <button className={`sidebar-toggle ${leftsidebarOpen ? "sidebar-open" : ""}`} onClick={toggleLeftSidebar}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.85719 3H15.1428C16.2266 2.99999 17.1007 2.99998 17.8086 3.05782C18.5375 3.11737 19.1777 3.24318 19.77 3.54497C20.7108 4.02433 21.4757 4.78924 21.955 5.73005C22.2568 6.32234 22.3826 6.96253 22.4422 7.69138C22.5 8.39925 22.5 9.27339 22.5 10.3572V13.6428C22.5 14.7266 22.5 15.6008 22.4422 16.3086C22.3826 17.0375 22.2568 17.6777 21.955 18.27C21.4757 19.2108 20.7108 19.9757 19.77 20.455C19.1777 20.7568 18.5375 20.8826 17.8086 20.9422C17.1008 21 16.2266 21 15.1428 21H8.85717C7.77339 21 6.89925 21 6.19138 20.9422C5.46253 20.8826 4.82234 20.7568 4.23005 20.455C3.28924 19.9757 2.52433 19.2108 2.04497 18.27C1.74318 17.6777 1.61737 17.0375 1.55782 16.3086C1.49998 15.6007 1.49999 14.7266 1.5 13.6428V10.3572C1.49999 9.27341 1.49998 8.39926 1.55782 7.69138C1.61737 6.96253 1.74318 6.32234 2.04497 5.73005C2.52433 4.78924 3.28924 4.02433 4.23005 3.54497C4.82234 3.24318 5.46253 3.11737 6.19138 3.05782C6.89926 2.99998 7.77341 2.99999 8.85719 3ZM6.35424 5.05118C5.74907 5.10062 5.40138 5.19279 5.13803 5.32698C4.57354 5.6146 4.1146 6.07354 3.82698 6.63803C3.69279 6.90138 3.60062 7.24907 3.55118 7.85424C3.50078 8.47108 3.5 9.26339 3.5 10.4V13.6C3.5 14.7366 3.50078 15.5289 3.55118 16.1458C3.60062 16.7509 3.69279 17.0986 3.82698 17.362C4.1146 17.9265 4.57354 18.3854 5.13803 18.673C5.40138 18.8072 5.74907 18.8994 6.35424 18.9488C6.97108 18.9992 7.76339 19 8.9 19H9.5V5H8.9C7.76339 5 6.97108 5.00078 6.35424 5.05118ZM11.5 5V19H15.1C16.2366 19 17.0289 18.9992 17.6458 18.9488C18.2509 18.8994 18.5986 18.8072 18.862 18.673C19.4265 18.3854 19.8854 17.9265 20.173 17.362C20.3072 17.0986 20.3994 16.7509 20.4488 16.1458C20.4992 15.5289 20.5 14.7366 20.5 13.6V10.4C20.5 9.26339 20.4992 8.47108 20.4488 7.85424C20.3994 7.24907 20.3072 6.90138 20.173 6.63803C19.8854 6.07354 19.4265 5.6146 18.862 5.32698C18.5986 5.19279 18.2509 5.10062 17.6458 5.05118C17.0289 5.00078 16.2366 5 15.1 5H11.5ZM5 8.5C5 7.94772 5.44772 7.5 6 7.5H7C7.55229 7.5 8 7.94772 8 8.5C8 9.05229 7.55229 9.5 7 9.5H6C5.44772 9.5 5 9.05229 5 8.5ZM5 12C5 11.4477 5.44772 11 6 11H7C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H6C5.44772 13 5 12.5523 5 12Z" fill="currentColor"></path>
            </svg>
          </button>
        )

        }

        <Navbar.Brand as={Link} to="/">
          <img 
            alt="LKC Logo"
            src={LKCLogo}
            width="115"
            height="30"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Custom Navbar Toggle Icon */}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            // Icon to display when expanded
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path d="M5 5L19 19M5 19L19 5" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            // Icon to display when collapsed
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path d="M3 12h18M3 6h18M3 18h18" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </Navbar.Toggle>


        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" onClick={closeNav}>
            <Nav.Link as={Link} to="/dashboard" active={window.location.pathname === "/dashboard"}>
              Home
            </Nav.Link>
            {/*GPT Menu*/}
            <NavDropdown title='GPT' id='basic_nav_dropdown'  className={`hover-dropdown ${isMainComponentActive() ? 'active' : ''}`} show={isDropdownOpen} onMouseEnter={handleDropdownMouseEnter} onMouseLeave={handleDropdownMouseLeave}>
                {/* <NavDropdown.Item as={Link} to="/gpt-3-5/rag" active={isSubComponentActive("/gpt-3-5/rag")} className="dropdown-items">
                GPT-3.5 | Retrieval Augmented Generation
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/gpt-4/rag" active={isSubComponentActive("/gpt-4/rag")} className="dropdown-items">
                GPT-4 | Retrieval Augmented Generation
                </NavDropdown.Item> */}
                <NavDropdown.Item as={Link} to="/gpt-4o/rag" active={isSubComponentActive("/gpt-4o/rag")} className="dropdown-items">
                GPT-4o | Retrieval Augmented Generation
                </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;